const replacePlaceholders = (text, placeholders) => {
    if (!placeholders)
        return text;
    const regEx = new RegExp(Object.keys(placeholders)
        .map((k) => k)
        .join("|"), "gi");
    return text?.replace(regEx, (matched) => placeholders[matched]);
};
export default replacePlaceholders;
//# sourceMappingURL=replacePlaceholders.js.map